import React, { useEffect, useState, useRef, Fragment, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
// import { coinState } from '../../App' 
import { getData, postData } from '../../Service/ApiMethod'
import { GET_SEEKER_PROFILE,Afterlogin, Beforlogin, RECOMMENDED_CANDIDATES, RECURITER_PROFILE, Selected_Candidate, UNLOCKNOW, loginUrl, vaccancy_url, Recruiter_Create_Message } from '../../Service/service'
// import AddToList from '../Vaccancy/AddToList'
import ApplicantsAvailability from '../Vaccancy/ApplicantsAvailability'
import MapView from './component/MapView'
import RoundsPopup from './component/RoundsPopup'
// import ShareButtons from './component/ShareButtons'
import TokenwarnPopup from './component/tokenwarnPopup'
import { useTranslation } from "react-i18next";
import AddToListRecomended from '../Vaccancy/toggles/AddToListRecomended'
import 'jspdf-autotable';
// import jsPDF from 'jspdf'
import axios from 'axios'
import { lang } from '../../lang'



const BlackScreen = (props) => { 
    const [ln,setLn] = useState('en')
    const [singleCandidateData, setSingleCandidateData] = useState()
    // const [unlockProfileData, setUnlockProfileData] = useState()
    const [isError, setIsError] = useState()
    const [contactDetails, setContactDetails] = useState(false)
    const [user_ID, setUser_ID] = useState(0)
    const [vacancyUserID, setVacancyUserID] = useState(0)
    const [vacancy, setVacancy] = useState([])
    const [addtolistPopupp, setAddtolistPopupp] = useState(false)
    const [showFullDetail, setShowFullDetail] = useState(false)
    const [showButtons, setShowButtons] = useState(props.item.round_status == "Unlocked"?true:false)
    const [lockdetailsunlock, setLockdetailsunlock] = useState(false)
    const [vacancyPopup, setVacancyPopup] = useState(true)
    const [roundPopup, setRoundPopup] = useState(false)
    const [phoneandemail, setPhoneandemail] = useState(props.item.round_status == "Unlocked"?true:false)
    const [tokenwarn, setTokenwarn] = useState(false)
    // const [showSharePopup, setShowSharePopup] = useState(false)
    const [userProfileData, setUserProfileData] = useState()
    // const [permission, setPermission] = useState(false)
    const [addresssw, setAddress] = useState('')

    useEffect(()=>{
        if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
    })


    const navigate = useNavigate()
    console.log('vacancyUserID', vacancyUserID)

    // const updatedCoins = useContext(coinState)
    // console.log('setCreditBalance', updatedCoins)

    const setBlackPopup = props?.setBlackPopupValue

    const ref = useRef(null);
    useOutsideAlerter(ref);

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setBlackPopup && setBlackPopup(false)
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    // const pdf = props?.item?.license
    // console.log('pfffffffffff', props?.item)

    // const pdfUrl = pdf.substring(2, pdf.length - 2);

   
    
    // const handleClick = () => {
 
    // window.open(pdfUrl, '_blank');

     
    // };


    // const getRecommendedCandidateData = () => {
    //     setSingleCandidateData(props?.item)
    //     console.log('RecommendedCandidateDatazzzzz', props?.item)
    // }

    console.log('single Candidate Data', singleCandidateData)

 

    const loginToken =  localStorage.getItem('catzapp_token');
    console.log('myData',  loginToken);
    // }

    const handleShare = async (id) => { 
        let _encodedSeekerId = window.btoa(id)
        console.log(_encodedSeekerId, "encoded seekrr")
        if (navigator?.share) {
            navigator?.share({
                title: `Share title`,
                message: `This is share description.`,
                url: "https://recruiter.catzapp.com/?id="+singleCandidateData?.user,
            })
                .then(() => console.log('shared sucessfully'))
                .catch(err => {
                    console.log('error ', err)
                })
        }

        console.log('seekerid', singleCandidateData?.user)
    }
   







    const handleContactDetails = (userID) => {
        setContactDetails(!contactDetails)
        setUser_ID(userID)
        const objDataSelectedCondidate = {
            "seeker_id": userID,
            "round_status": "unlocked"
        }
        if (!contactDetails) {
            console.log("applicant id: ", userID)
            const selected_candidate = () => {
                postData(objDataSelectedCondidate, Selected_Candidate)
                    .then(response => response.json())
                    .then(data => console.log(data))
                    .catch((err) => {
                        setIsError(err.message);
                        console.log(isError);
                    })
            }
            const handleVacancy = () => {
                getData(vaccancy_url+"?pgNo=1&keyword=")
                    .then(res => res.json())
                    .then(data => {
                        console.log("VacnacyData", data.data)
                        setVacancy(data.data.vacancy?.filter((item) => (item?.title )))
                    })
            }
            selected_candidate()
            handleVacancy()
        }
    }

    const handleSelectedTitle = (id) => {
        console.log("chedckckkck",id);
        setVacancyUserID(id)
    }

    const handleOK = () => {


        if (userProfileData?.credit_balance >= 0) {
            if ((vacancyUserID !== undefined)) {
                const objDataUnlockNow = {
                    "jobseeker_id": props.item.body == undefined ? props.item.id:props.item.seeker_id,
                    "vacancy": vacancyUserID
                }
             
                console.log(objDataUnlockNow,"vvvvvvvvvv",UNLOCKNOW);
                postData(objDataUnlockNow, UNLOCKNOW)
                    .then(response => response.json())
                    .then(data => {
                        console.log('updatedCoins', data)
                       
                       
                        if(data?.message != "You do not have enough credits to unlock this profile. Please upgrade your subscription plan"){
                            setShowButtons(true)
                            setPhoneandemail(true)
                            alert(data?.message)
                        }else{
                            
                            alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.new["Buy Credit to Unlock the Candidates and Proceed further with the process to send messages, chat or call."]:"")
                        }
                        // updatedCoins(2)
                    })
                    .catch((err) => {
                        setIsError(err.message);
                        console.log(err.message)
                    })
                console.log("User_ID", user_ID)
                console.log("vacancyUserID", vacancyUserID)

                setContactDetails(!contactDetails)
                
                if (roundPopup) {
                    setRoundPopup(false)
                } else {
                    setRoundPopup(false)
                }

            } else {
                setContactDetails(false)
                setPhoneandemail(false)
            }

            sessionStorage.setItem('unlocked for credit', true)

        } else {
            alert('Please purchase credits')

        }


    }

    const gotoSelectHire = (item) => {
        setBlackPopup(false)
        navigate('/hire-details', { state: { item } })
    }
    const handleClose = () => {
        setBlackPopup(false)
    }

    useEffect(() => {
        // getRecommendedCandidateData()
        getDataall()
    }, [])


    useEffect(() => {
        getData(RECURITER_PROFILE)
            .then(res => res.json())
            .then(data => {
                console.log('profile data', data.data)
                setUserProfileData(data.data)
            })
    }, [])

    const getDataall=async()=>{
        console.log(props.item.body,props.item.id,props.item.seeker_id,props.item,"okkkkkkkkkkkkk")
        let request = {
          "candidate_id": props.item.body == undefined ? props.item.user == undefined?props.item.id :props.item.user:props.item.user == undefined?props.item.seeker_id :props.item.user
        };
        console.log(request,"pdddddddddddddddddddddddddddsssssssssssss",props);

        const url = 'https://api.catzapp.com/recruiter/candidateProfile_v1/';
        const token = await localStorage.getItem("catzapp_token");
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` // Include your token in the Authorization header
          },
          body: JSON.stringify(request) // Convert the data to JSON string
        };
        
        fetch(url, requestOptions)
          .then(response => response.json())
          .then(data => {
            // Handle the response data
            console.log(data);
            console.log('8888888888888888888222222222222222', data.data)
            setSingleCandidateData(data.data)
            handleGetAddress(data.data.latitude, data.data.longitude)
          })
          .catch(error => {
            // Handle any errors
            console.error('Error:', error);
          });
        

          
          const handleGetAddress = async (latitude, longitude) => {
            try {
                const response = await axios.get(
                    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyAn7_5pFRSJ_i1lbbiitBzZinnYY7VTGxk`
                );
                if (response.data.results.length > 0) {
                    setAddress(response.data.results[0].formatted_address);
                } else {
                    setAddress("Address not found");
                }
            } catch (error) {
                console.error(error);
                setAddress("Error fetching address");
            }
        };

        // postData(request, GET_SEEKER_PROFILE)
        // // postDataWithToken(request, Constant.end_Point.GET_SEEKER_PROFILE)
        //   .then(res => {
        //     console.log('8888888888888888888', res.data)
        //     setSingleCandidateData(res.data)
        //     // setLoader(false)
        //     // setValue(false)
        //     // setDatafound(res.data);
        //     // onMapClick(res.data.latitude,res.data.longitude)
        //     // setLicencesList(JSON.parse(res.data.license));
        //     // setShowpro(true)
        //     // if (res.status_code === 200) {
        //     //   console.log("res", res);
        //     // } else {
        //     //   setMessage(res.error_message)
        //     //   setApplyModal(true)
        //     // }
        //   })
        //   .catch(error => { });
      }






    const { t } = useTranslation()

    return ( 
        <>
            {/** <div style={{ position: 'fixed', right: '10%', top: '20%', zIndex: '99999999999', height: '75vh', overflow: 'auto' }}>
          {
            searchData?.map((singleCandidateData, index) => {
              return (
               
              )
            }) 
          } </div>*/}
            {singleCandidateData &&
                <>
                    <div className="blur-screen-full-area applicants-details-container blackscreen" style={{  }} ref={ref}>
                        <div className="row" >
                            <div className="col-10 pl-0">
                                <div className="row d-flex">
                                    <div className="map-left px-0 mb-3 flex-center relative"  >
                                        {/** <img src="./images/msg1.png" className="" alt="" />*/}
                                        <div class="map-profile">
                                        <img src={singleCandidateData?.image || "../images/Vector.png"} className="" alt=""  />
                                        </div>
                                        {singleCandidateData?.is_premium &&
                                            <span className="premium" style={{ left: "2px", bottom: "-11px" }}>{t('Premium')}</span>}

                                    </div>
                                    <div className="map-right px-2" >
                                        <p className="candidate-name" style={{ }}>
                                            {(singleCandidateData?.first_name) ? (singleCandidateData?.first_name) : 'Unknown'} {(singleCandidateData?.last_name) ? (singleCandidateData?.last_name) : 'Unknown'}
                                        </p>

                                        <p className="designation text-bold text-white">
                                            {(singleCandidateData?.profile_title) ? (singleCandidateData.profile_title) : ''}
                                            {/* <span className="transparent-border-btn ml-3">
                                            Urgent Vacancy
                                        </span> */}
                                        </p>
                                    </div>
                                </div>
                                {showButtons &&
                                <>
                                    <div  style={{ color: 'white' }}>
                                        <img src='../images/call-reciever.png' alt='img' style={{marginRight:"10px",width:20}}/>
                                        {(singleCandidateData?.mobile_number)} 
                                        </div>
                                    <div style={{ color: 'white' }}>
                                    <img src='../images/email.png' alt='img' style={{marginRight:"10px",width:20}}/>
                                     {(singleCandidateData?.email)} 
                                        </div>
                                </>
                            }
                                {(singleCandidateData?.short_description) ?
                                    <p className="heading h5 mt-2 text-white">
                                        {(singleCandidateData?.short_description)} </p>
                                    : ''}

                                <p className="sub-heading text-white font-12 mt-2">
                                    {t('About Me')}
                                </p>
                                <p className="text-white text break-para">
                                    {singleCandidateData?.cover_latter}
                                </p>
                                <p className="sub-heading text-white font-12 mt-2">
                                    {t('Address')}
                                </p>
                                <p className="text-white text" style={{overflow: "hidden"}}>
                                    {addresssw}
                                </p>
                                <p className="sub-heading text-white font-12 mt-2">
                                    {lang && Object.keys(lang).length > 0 ? lang[ln]?.BlackCard['Experience']:""}
                                </p>
                                {/* {singleCandidateData?.experience?.map((experience) => {
                                    return (
                                        <p className="text-white text" key={experience.id}>
                                            {experience?.experience} {experience?.experience > 1 ? ' Years of Experience required' : '  Year of Experience required'}
                                        </p>
                                    )
                                })} */}

                                <p className="sub-heading text-white font-12 mt-2">
                                    {lang && Object.keys(lang).length > 0 ? lang[ln]?.BlackCard['Employment Type']:""}
                                </p>
                                <p className="text-white text">
                                    {lang && Object.keys(lang).length > 0 ? lang[ln]?.new[singleCandidateData?.employment_type]:""}

                                    {(parseInt(singleCandidateData?.availability)) > 0 &&
                                        <span className="text-warning text-bold">
                                            ( {t('Available')} {singleCandidateData?.availability})
                                        </span>
                                    }

                                </p>
                                <p className="sub-heading text-white font-12 mt-2">{lang && Object.keys(lang).length > 0 ? lang[ln]?.BlackCard['Expected Salary']:""}</p>
                                <p className="text-white text">
                                    {singleCandidateData?.currency} {singleCandidateData?.expected_salary} {singleCandidateData?.compensation_details}
                                </p>
                                {/* 
                            <p className="sub-heading text-white font-12 mt-2">
                                Current Location
                            </p>
                            <p className="text-white text">INDIA</p> */}

                                {/* <p className="sub-heading text-white font-12 mt-2">
                                About Compny
                            </p>
                            <p className="text-white text">
                                Lorem ipsum dolor sit amet, consectadipiscing elit, sed do
                                eiusmsit at,consectetur adipiscing eliem Lorem ipsum dolor
                                sit amet, consectetur adipiscing elit, sed do eiusm
                            </p> */}


                                {!showFullDetail &&
                                    <button className="jobseeker-btn mt-3"
                                        style={{ background: 'blue' }}
                                        onClick={(e) => {
                                            // e.stopPropagation()
                                            setShowFullDetail(true)
                                        }}
                                    >
                                        {t('See Full Details')}
                                    </button>
                                }
                            </div>
                            <div className="col-2 px-0">
                                
                                <div className=" flex-column sticky-top">
                                    {
                                        props?.item.percentage_match == undefined ? null:(<div className="white-circle flex-center flex-column">
                                        <p className="font-8">{parseInt(props?.item.percentage_match)}%</p>
                                        <p className="font-8">{lang && Object.keys(lang).length > 0 ? lang[ln]?.BlackCard['Match']:""}</p>
                                    </div>)
                                    }
                                    
                                    <div className="white-circle flex-center" onClick={(e) => {
                                        // e.stopPropagation()
                                        setRoundPopup(true)
                                            (!phoneandemail && alert('Please unlock profile first'))
                                    }}>
                                        <img src="./images/bookmark.png" alt="" />
                                    </div>
                                    <div className="white-circle flex-center" onClick={() => {
                                        console.log("chekcccccccc",singleCandidateData?.user)
                                        setAddtolistPopupp(true)}} >
                                        <img className="send-job" src="./images/send-job.png" alt="" style={{ cursor: "pointer" }}/>
                                    </div>
                                    {addtolistPopupp && <AddToListRecomended setAddtolistPopupp={setAddtolistPopupp} seekerID={singleCandidateData?.user} />}

                                    <div className="white-circle flex-center" onClick={(e) => {
                                        // e.stopPropagation() 
                                        handleShare(singleCandidateData?.user_id)
                                        // setShowSharePopup(!showSharePopup)
                                    }}>
                                        <img src="./images/share-icon.png" alt="" />
                                    </div>
                                    {/* {showSharePopup &&
                                        <div style={{ position: 'fixed', width: '70px', marginLeft: '-10px', height: '40px', background: 'white', display: 'flex', justifyContent: 'center', alignContent: 'center', padding: '3px' }}>
                                            <ShareButtons url={`https://www.catzapp.com/jobs/OA==`} />
                                        </div>
                                    } */}
                                    {
                                    !phoneandemail &&
                                        <div className="jobseeker-circle flex-center" onClick={(e) => {
                                            // e.stopPropagation()
                                            setVacancyPopup(true)
                                            setLockdetailsunlock(true)
                                            handleContactDetails(singleCandidateData?.user_id)
                                        }}
                                            style={{ background: 'blue' }}
                                        >
                                            <img src="./images/unlcoked-profile-white.png" alt="" />
                                        </div>}

                                    {/*<div
              className="red-circle flex-center"
              onClick={(e)=>{
                e.stopPropagation()
                props.closePopup()}}
            >
              <img src="./images/cross.png" alt="" />
            </div>*/}
                                    {showButtons && (
                                        <>
                                            <div className="white-circle flex-center" onClick={(e) => {
                                                // e.stopPropagation()
                                                console.log("singleCandidateData",singleCandidateData)
                                                const obj = {
                                                    "jobseeker_id": singleCandidateData?.user
                                                }
                                                console.log(obj,"ddd")
                                                postData(obj, Recruiter_Create_Message)
                                                    .then(res => res.json())
                                                    .then(data => {
                                                        console.log('get message candidate response', data?.data)
                                                        // setCandidateMessageData(data.data)
                                                        navigate('/message', { state: { data: data?.data } })
                                                    })
                                                    .catch((err) => {
                                                        console.log(err.message)
                                                    })
                                                // navigate('/message')
                                            }} >
                                                <img className='msg-icon' src="../images/messages.png" alt="" />
                                            </div>
                                            <div
                                                className="red-circle flex-center"
                                                onClick={(e) => {
                                                    // e.stopPropagation()
                                                    handleClose()
                                                }}
                                            >
                                                <img src="../images/cross.png" alt="" />
                                            </div>
                                            <div className="yellow-circle flex-center flex-column" onClick={(e) => {
                                                // e.stopPropagation()
                                                gotoSelectHire(singleCandidateData)
                                            }}>
                                                <p className="" style={{ fontWeight:"bold" }}>{t('Hire')}</p>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        {contactDetails ?
                            vacancyPopup &&
                            <div className="blur-screen-full-area inner-modal flex-center" >
                                {/* <div className="form-container my-3" style={{ position: 'fixed', right: '45%', top: '50%' }}> */}
                                <div className="form-container d-flex flex-column align-items-center  my-3" style={{ position: 'fixed' }}>
                                    <select name='Select Vacancy' onChange={(e) => handleSelectedTitle(e.target.value)}>
                                        <option value='Select Vacancy' default>{t('Select Vacancy')}</option>
                                        {vacancy?.map((item) =>
                                            <option key={item?.id} value={item?.id} >{item?.title.substring(0, 50)}</option>
                                        )}
                                    </select>
                                    <div className='mt-3'>
                                    <button
                                        // style={{ marginLeft: '10px', borderRadius: '5px' }}
                                        className="btn-primary"
                                        style={{  borderRadius: '5px' }}
                                        onClick={(e) => {
                                            // e.stopPropagation()
                                            // handleOK()
                                            if ((vacancyUserID != 'Select Vacancy') && (vacancyUserID != 0)) {
                                                setTokenwarn(true)
                                            } else {
                                                setTokenwarn(false)
                                                alert('Please select vacancy first!')
                                            }

                                        }}>{t('Ok')}</button>
                                    <button
                                        className=" btn-secondary ml-2"
                                        style={{  borderRadius: "5px" }}
                                        onClick={() => {
                                            setContactDetails(false)
                                            setVacancyPopup(false)
                                        }}>{t('Close')}</button>
                                    </div>
                                    
                                </div>
                                {tokenwarn &&
                                    <TokenwarnPopup
                                        setTokenwarn={setTokenwarn}
                                        // setPermission={setPermission}
                                        message={lang && Object.keys(lang).length > 0 ? lang[ln]?.BlackCard["Are you sure to unlock the profile"]:""}
                                        handleOK={handleOK}
                                    />
                                }
                            </div> : ''}



                        <div className="applicants-distance">
                            <p className="distance-text">
                                <img
                                    src="./images/location.png"
                                    className=" img-size16"
                                    alt=""
                                />
                                {parseInt(props?.item.distance)} {t('KM Away')}
                            </p>
                        </div>
                        {showFullDetail &&
                            <div style={{marginTop:20}}>
                                <div style={{ marginTop: "-20px", marginBottom: "10px" }}>
                                    <p className="sub-heading text-white font-12 mt-2">{t('Skills')}</p>
                                    {/* {singleCandidateData?.skills?.map((skill, i) => {
                                        return ( */}
                                            <div className=" " style={{ display: "inline-block", marginBottom: '5px' }} >
                                                <span className="skill-detaill">
                                                    {singleCandidateData?.skills}</span>
                                            </div>
                                        {/* )
                                    })} */}
                                    <p className="sub-heading text-white font-12 mt-2">
                                        {t('Education')}
                                    </p>
                                    
                                            <div className=" " style={{ display: "inline-block" }} >
                                               <span className="transparent-border-btn">
                                                    {singleCandidateData?.highest_education_name}</span>
                                            </div>
            
                                    <p className="sub-heading text-white font-12 mt-2">
                                        {lang && Object.keys(lang).length > 0 ? lang[ln]?.LastL['Passout Year']:""}
                                    </p>
                                    <div>
                                        <span className="transparent-border-btn">
                                            {singleCandidateData?.passout_year}
                                        </span>
                                    </div>
                                    {
    singleCandidateData?.license != [] ? (<>
    <p className="sub-heading text-white font-12 mt-2">
                                        {t('Licenses')}
                                    </p>
                                    {
                                       singleCandidateData?.license.map((item,i)=>(
                                        <div>
                                        <span className="transparent-border-btn"
                                onClick={()=>{
                                    const pdfUrl = singleCandidateData?.license[i];
                                    const cleanedUrl = pdfUrl.replace(/"/g, '');
                                    console.log(cleanedUrl,"pdfUrl")
                                    window.open(cleanedUrl, '_blank');
                                }}
                                 >
                                  {t('Licenses')} {i+1}
                                </span>
                                        {/* <span className="transparent-border-btn">
                                    {t('License Name 2')}
                                </span> */}
                                    </div>
                                       )) 
                                    }
    </>):null
}
                                    {/* <p className="sub-heading text-white font-12 mt-2">
                                        {t('Licenses')}
                                    </p> */}
                                    <div>

                                    {
    singleCandidateData?.certificate != [] ? (<>
    <p className="sub-heading text-white font-12 mt-2">
                                        {t('certificate')}
                                    </p>
                                    {
                                       singleCandidateData?.certificate.map((item,i)=>(
                                        <div>
                                        <span className="transparent-border-btn"
                                onClick={()=>{
                                    const pdfUrl = singleCandidateData?.certificate[i];
                                    const cleanedUrl = pdfUrl.replace(/"/g, '');
                                    console.log(cleanedUrl,"pdfUrl")
                                    window.open(cleanedUrl, '_blank');
                                }}
                                 >
                                  {t('certificate')} {i+1}
                                </span>
                                        {/* <span className="transparent-border-btn">
                                    {t('License Name 2')}
                                </span> */}
                                    </div>
                                       )) 
                                    }
                                   
    </>):null
}




                                        {/* <span className="transparent-border-btn"
                                        onClick={()=>{
                                            handleClick()
                                            // download()
                                        }}>{t('Licenses')}
                                            
                                        </span> */}
                                        {/* <span className="transparent-border-btn">
                                            {t('License Name 2')}
                                        </span> */}
                                    </div>

                                    {!lockdetailsunlock ? <div className="mt-2">
                                        <span className="transparent-border-btn px-3">
                                            <img
                                                src="./images/lock-white.png"
                                                className="mr-2"
                                                alt=""
                                            />
                                            {t('Contact Details Locked')}
                                        </span>
                                    </div> : ''}

                                </div>
                                <div style={{  }}>
                                    <ApplicantsAvailability recommendedCandidateData={singleCandidateData} />
                                </div>
                                <div style={{  marginTop: '-9px', marginBottom: '-10px' }}>
                                    <MapView mapHeight='400px' userLocation={singleCandidateData} />
                                </div>
                            </div>
                        }
                        {roundPopup && phoneandemail &&
                            <RoundsPopup seekerID={singleCandidateData} setRoundPopup={setRoundPopup} />
                        }
                    </div>
                </>
            }

        </>
    )
}

export default BlackScreen